import React from 'react';
import PropTypes from 'prop-types';
import { getSizedImageUrl } from '@shopify/theme-images';

import { formatMoney, getImgSrcsets } from '../../functions';
import AddToCartButtonContent from '../AddToCartButton/AddToCartButtonContent';

const RecentItemHomeware = (props) => {
  const { product } = props;
  const measurementSystem = window.getMeasurementSystem();
  let measurements = product.measurements && (typeof product.measurements === 'object')
    ? product.measurements[measurementSystem]
    : product.measurements;

  if (measurements && measurements.includes(':')) {
    measurements = measurements.split(',') || '';
  }

  const productVariants = Array.isArray(measurements)
    ? product.variants.map((variant) => {
      let foundItem = measurements.find((measurementItem) => {
        const measurementItemPair = measurementItem.split(':');

        return (measurementItemPair.length === 2 && variant.title.includes(measurementItemPair[0]));
      });

      foundItem = foundItem && foundItem.includes(':')
        ? foundItem.split(':')
        : null;

      let variantTitle = variant.title;
      if ((foundItem && foundItem[1] && foundItem[1].toLowerCase() !== 'null' && foundItem[1].toLowerCase() !== 'n/a') && foundItem[0] !== foundItem[1]) {
        if (foundItem[0].includes(' x ')) {
          variantTitle = variant.title.replaceAll(foundItem[0], foundItem[1]);
        } else {
          variantTitle = variant.title.replace(foundItem[0], `${foundItem[0]} ${foundItem[1]}`);
        }
      }

      return { ...variant, title: variantTitle };
    })
    : product.variants.map((variant) => ({
      ...variant,
      title: (product.measurements && product.measurements.metric && product.measurements[measurementSystem])
        ? variant.title.replaceAll(
          product.measurements.metric,
          product.measurements[measurementSystem],
        )
        : variant.title
      ,
    }));
  return (
    <div className="product-card" data-shipping-region={product.shippingRegion && product.shippingRegion}>
      <a href={product.url}>
        <img
          src={product.featured_image && getSizedImageUrl(product.featured_image, '600x')}
          srcSet={product.featured_image && getImgSrcsets(product.featured_image)}
          className="product-card__img bg-grey"
          sizes="(min-width:992px) 33vw, (min-width:768px) 50vw, 100vw"
          alt={productVariants[0].title}
        />
      </a>
      <h3 className="product-card__title h3 mb-0">
        <a href={product.url}>{product.title}</a>
      </h3>
      <p className="mb-1 p-small color-subtle">
      {Shopify.currency.active + " " + formatMoney(product.price)}
        {product.price_varies ? '+' : ''}
      </p>
      <form action="/cart/add" method="post" encType="multipart/form-data" className="product-card__bottom">
        <div className="product-card__variant">
          {
						productVariants.length === 1
              && (
              <div>
                {productVariants[0].title}
                <input type="hidden" name="id" id={`productSelect-${product.id}`} value={productVariants[0].id} />
              </div>
              )
					}
          {
						productVariants.length > 1
              && (
              <select
                name="id"
                className="product-card__select"
                id={`productSelect-${product.id}`}
                defaultValue={productVariants.find((variant) => !!variant.available || variant).id}
              >
                {productVariants.map((variant) => {
                  if (variant.available) {
                    return (
                      <option key={variant.id} value={variant.id}>
                        { variant.title }
                        {' '}
                        &ndash;
                        {Shopify.country === 'US' ? 'USD' : Shopify.country === 'AU' ? 'AUD' : ''} { formatMoney(variant.price) }
                      </option>
                    );
                  }
                  return (
                    <option key={variant.id} disabled="disabled">
                      {variant.title}
                      {' '}
                      - sold out
                    </option>
                  );
                })}
              </select>
              )
}
        </div>
        <div className="product-card__cta">
          <div className={product.shippingRegion && 'geo-hidden geo-hidden--atc'}>
            <AddToCartButtonContent
              quantity="1"
              variantInputId={`productSelect-${product.id}`}
              isSmall
              items={productVariants.map((variant) => ({
							  variantId: variant.id.toString(),
							  title: product.title,
							  info: variant.title,
							  itemPriceCents: variant.price,
							  image: product.featured_image && getSizedImageUrl(product.featured_image, '600x'),
							  imgSrcset: product.featured_image && getImgSrcsets(product.featured_image),
							  variantName: variant.title,
							  available: variant.available,
              }))}
            />
          </div>
          {	product.shippingRegion && (
          <a
            href={product.url}
            className="button button--small geo-hidden geo-hidden--enquire"
          >
            <span className="text-inquire">Inquire</span>
            <span className="text-enquire">Enquire</span>
          </a>
          )}
        </div>
      </form>
    </div>
  );
};

RecentItemHomeware.propTypes = {
  product: PropTypes.shape({
    variants: PropTypes.array,
    title: PropTypes.string,
    measurements: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(PropTypes.any),
    ]),
    url: PropTypes.string,
    featured_image: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    price_varies: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    shippingRegion: PropTypes.string,
  }).isRequired,
};

export default RecentItemHomeware;
